(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-home"] && !Shopify.designMode) return;
  try {
    
function initLayered(root){if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.layered-track');root.querySelectorAll('[data-layered-scroll]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.layeredScroll)*track.clientWidth*.8})));root.querySelectorAll('a[href^="#LayeredConcept"]').forEach(link=>link.addEventListener('click',()=>{root.querySelector('.layered-concept').open=true;}));}
document.querySelectorAll('.layered-home').forEach(initLayered);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.layered-home').forEach(initLayered));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
